import { useMediaQuery } from 'react-responsive';

import { breakpointLargeTablet, breakpointTablet } from 'src/styles/breakpoints';

export const useTabletMediaQuery = (): boolean => useMediaQuery({ minWidth: breakpointTablet });
export const useLargeTabletMediaQuery = (): boolean => useMediaQuery({ minWidth: breakpointLargeTablet });
